__turbopack_context__.v({
  "fullBleed": "aMx1_W_fullBleed",
  "slideFrame": "aMx1_W_slideFrame",
  "slideImage": "aMx1_W_slideImage",
  "slideMedia": "aMx1_W_slideMedia",
});
